/* src/app/views/contract-cancellation/view-pending-cancellations/view-pending-cancellations.component.scss */
:host {
  display: block;
}
.pending-cancellations-container {
  margin: 0 auto 24px;
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 16px 36px rgba(18, 38, 63, 0.08);
  overflow: hidden;
}
.container-header {
  padding: 30px 42px 10px;
}
.pending-cancellations-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.pending-cancellations-header .title {
  margin: 0;
  font-size: clamp(30px, 4vw, 48px);
  line-height: 1.08;
  color: #14345f;
}
.pending-cancellations-header .sub-title {
  color: #5f6e82;
  font-size: clamp(16px, 1.35vw, 28px);
  line-height: 1.32;
}
.pending-cancellations-body {
  padding: 14px 42px 30px;
}
.pending-cancellations-card {
  border: 1px solid #d7e1f2;
  border-radius: 14px;
  background: #ffffff;
  padding: 24px;
}
.pending-cancellations-card-header {
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e1e8f2;
}
.pending-cancellations-card-header h2 {
  margin: 0;
  font-size: var(--app-page-title-size);
  line-height: var(--app-page-title-line-height);
  color: var(--app-page-title-color);
  font-weight: 400;
}
.pending-cancellations-card-header p {
  margin: 8px 0 0;
  color: #5f5f5f;
  font-size: 16px;
  line-height: 22px;
}
.chassi-cell {
  font-weight: 600;
  letter-spacing: 0.01em;
}
.action-cell {
  white-space: nowrap;
  text-align: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.action-cell-inner {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-cell .pending-process-button {
  margin: 0 !important;
}
.pending-process-button {
  min-height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.pending-process-button .action-button-label {
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1;
}
.pending-process-button .pi {
  font-size: 0.85rem;
  line-height: 1;
}
.no-request {
  color: #667788;
  text-align: left;
  padding: 16px !important;
}
:host ::ng-deep .pending-cancellations-table .p-datatable-wrapper {
  border-radius: 10px;
}
:host ::ng-deep .pending-cancellations-table .p-datatable-table {
  min-width: 960px;
}
:host ::ng-deep .pending-cancellations-table .p-datatable-thead > tr > th:last-child,
:host ::ng-deep .pending-cancellations-table .p-datatable-tbody > tr > td:last-child {
  text-align: center !important;
}
:host ::ng-deep .pending-cancellations-table .p-datatable-tbody > tr > td.action-cell {
  text-align: center !important;
}
:host ::ng-deep #home-content .pending-cancellations-table .app-filter-button.pending-process-button {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}
:host ::ng-deep .pending-cancellations-table .p-datatable-thead > tr > th.action-header {
  text-align: center !important;
}
@media (max-width: 1024px) {
  .container-header {
    padding: 24px 24px 8px;
  }
  .pending-cancellations-body {
    padding: 10px 24px 24px;
  }
  .pending-cancellations-card {
    padding: 18px;
  }
  .pending-cancellations-card-header h2 {
    font-size: clamp(26px, 5vw, 38px);
  }
  .pending-cancellations-card-header p {
    font-size: 17px;
  }
}
@media (max-width: 768px) {
  .container-header {
    padding: 18px 16px 6px;
  }
  .pending-cancellations-body {
    padding: 8px 16px 18px;
  }
  .pending-cancellations-card {
    padding: 14px;
  }
  .pending-cancellations-card-header {
    margin-bottom: 12px;
    padding-bottom: 10px;
  }
  .pending-cancellations-card-header h2 {
    font-size: clamp(24px, 8vw, 30px);
  }
  .pending-cancellations-card-header p {
    font-size: 15px;
  }
  .pending-process-button {
    min-height: 34px;
    padding: 0 10px;
    gap: 6px;
  }
  .pending-process-button .action-button-label {
    font-size: 0.82rem;
  }
}
/*# sourceMappingURL=view-pending-cancellations.component-EU3IZXOC.css.map */
